export enum IntegrationType {
  Braze = `braze`,
  Marketo = `marketo`,
  UrbanAirship = `urbanairship`,
  FacebookAds = `facebookads`,
  GoogleAds = `googleads`,
  Iterable = `iterable`,
  TestPartnerWebhookIntegration = `testpartnerwebhook`,
  MoengageWebhook = `moengagewebhook`,
  ChameleonWebhook = `chameleonwebhook`,
  AppcuesWebhook = `appcueswebhook`,
  InsiderWebhook = `insiderwebhook`,
  LeanplumWebhook = `leanplumwebhook`,
  OnesignalWebhook = `onesignalwebhook`,
  WebengageWebhook = `webengagewebhook`,
  KameleoonWebhook = `kameleoonwebhook`,
  MailchimpWebhook = `mailchimpwebhook`,
  VwoWebhook = `vwowebhook`,
  TaplyticsWebhook = `taplyticswebhook`,
  XtremepushWebhook = `xtremepushwebhook`,
  ApptimizeWebhook = `apptimizewebhook`,
  ClevertapWebhook = `clevertapwebhook`,
  CustomWebhook = `customwebhook`,
  SegmentWebhook = `segmentwebhook`,
  Salesforcemc = `salesforcemc`,
  LaunchDarklyWebhook = `launchdarklywebhook`,
  BlitzllamaWebhook = `blitzllamawebhook`,
  ProductboardWebhook = `productboardwebhook`,
  ABTastyWebhook = `abtastywebhook`,
  FlagshipWebhook = `flagshipwebhook`,
  PushwooshWebhook = `pushwooshwebhook`,
}

export enum ExportModalStep {
  History = 1,
  SelectType,
}

export enum ExportStatus {
  Created = 0,
  Started,
  Finished,
  Errored,
}
